import Vue from 'vue';
import accounting from 'accounting';
import pluralize from 'pluralize';

Vue.filter('duration', (value) => {
  const dt = new Date(value * 1000);
  const hours = dt.getUTCHours();
  const minutes = dt.getUTCMinutes();
  const seconds = dt.getSeconds();
  if (hours) {
    return hours.toString().padStart(2, '0') + ':' + minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
  }
  return minutes.toString().padStart(2, '0') + ':' + seconds.toString().padStart(2, '0');
});

Vue.filter('money', (number, symbol = '$', decimals = 2) => {
  return accounting.formatMoney(number, symbol, decimals)
});

Vue.filter('number', (number, precision = 0, thousand, decimal) => {
  return accounting.formatNumber(number, precision, thousand, decimal);
});

Vue.filter('pluralize', function (number, word, inclusive = true) {
  return pluralize(word, number, inclusive)
});
